module.exports = __webpack_public_path__ + "img/4_42.265b59c9.png";